<ng-template #balBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('tenant.save-tenant-first' | translate)
                : ('common.missing-data-for-save' | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'tenant.save-tenant-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div #balBlock class="h-full" [blocked]="!model.id" [blockUi]="balBlockUi">
    <!-- make sure tenantId is in there first render -->
    @if (tenantId) {
        <app-tenant-bank-account-link-list-widget
            [autoFocusSearch]="false"
            [tenantId]="tenantId"
            [addInDialog]="true"
            [dialogEditMode]="true"
        />
    }
</blockable-div>
